module.exports = __webpack_public_path__ + "static/media/default-village.adc7a77a.png";